<template>
    <div>
        <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
            <app-sidebar></app-sidebar>
            <div id="page-content-wrapper" style="width:100%">
                <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar" style="cursor:pointer">view_headline</i>
                <app-navbar></app-navbar>
                <div class="container-fluid mt-5">
                    <div class="col-sm-12">
                        <div class="row dblock">
                            <div class="row">
                                <div class="col-md-12">
                                    <vs-breadcrumb align="left" :items="
                      [
                        {title: 'You are here : '},
                        {
                          title: 'Reports',
                          active: true
                        }
                      ]"></vs-breadcrumb>
                                    <div class="heading mt-3">
                                        <h3 class="text-secondary">Reports</h3>
                                    </div>
                                </div>
                            </div>
    
                            <div class="form-row">
                                <div class="col-sm-12">
                                    <!-- new form popup starts -->
                                    <b-card>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="table-responsive">
                                                        <table class="table table-hover table-stripped">
                                                            <tr>
                                                                <th>Sr#</th>
                                                                <th>Title</th>
                                                                <th></th>
                                                                <th class="text-center">View</th>
                                                                <th></th>
    
                                                            </tr>
                                                            <tr v-for="(item, index) in trainingArr" v-bind:key="item.id">
                                                                <td>{{index+1}}</td>
                                                                <td class="text-capitalize" style="width:40%">{{item.title}}</td>
    
                                                                <td>
                                                                    <div class="text-center">
                                                                        <router-link :to="{
                                    path:
                                      '/dashboard/CountryRepresentative/briefTrainingReport',
                                    query: { trainingId: item.training_code } }" class="training-report report-button">Brief Training Report</router-link>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                  <div class="text-center">
                                                                        <router-link :to="{
                                    path:
                                      '/dashboard/CountryRepresentative/analysisReport',
                                    query: { trainingId: item.training_code } }" class="overall-report report-button">Overall Training Analysis</router-link>
    
                                                                        </div>
                                                                </td>
    
                                                                <td>
                                                                  <div class="text-center">
                                                                        <router-link :to="{
                                    path:
                                      '/dashboard/CountryRepresentative/individualAnalysis',
                                    query: { trainingId: item.training_code } }" class="individual-report report-button">Individual Training Analysis</router-link>
    
                                                                    </div>
    
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card>
                                    <!-- new form popup ends -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import Navbar from "./Navbar";
    import Sidebar from "./Sidebar";
    import axios from "axios";
    
    import "bootstrap/dist/css/bootstrap.css";
    
    // Import date picker css
    import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
    export default {
        data: () => ({
            isSidebar: false,
            trainingArr: [],
        }),
        mounted() {
            axios.defaults.headers['Authorization'] = localStorage.getItem('token')
            // Set the initial number of items
            this.getTrainings();
        },
        components: {
            "app-navbar": Navbar,
            "app-sidebar": Sidebar
        },
        methods: {
            // this will route to training wizard
    
            openLoading() {
                this.$vs.loading({
                    type: "material"
                });
            },
            closeLoading() {
                this.$vs.loading.close();
            },
        getTrainings() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/get/all/training/reports/admin/" +
                    JSON.parse(localStorage.getItem("currentUser")).id

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingArr = response.data;
                });
        },
        }
    };
    </script>
    
    <style scoped>
    #menu-toggle {
        display: none;
    }
    
    @media (max-width: 768px) {
        #menu-toggle {
            display: block;
        }
    }
    
    @media (max-width: 550px) {
        .con-select {
            flex-direction: column;
        }
    
        .con-select .vs-select {
            width: 100%;
        }
    }
    
    .frm-title {
        text-align: center;
        padding: 10px;
        color: #009ad2;
        /* border-bottom: 2px solid #009ad2; */
    }
    
    
    /****  floating-Lable style end ****/
    
    
    .report-button{
      padding: 8px 12px;
      border-radius: 5px;
      color: #fff;
      text-decoration: none;
      text-align: center;
      font-size: .8rem;
    }
    .training-report{
      background-color: #009ad2;
    }
    .overall-report{
      background-color: rgb(70 201 58);
    }
    .individual-report{
      background-color: rgb(255 71 87);
    }
    </style>
    